import { render, staticRenderFns } from "./addClassDialog.vue?vue&type=template&id=582b1e47&scoped=true"
import script from "./addClassDialog.vue?vue&type=script&lang=js"
export * from "./addClassDialog.vue?vue&type=script&lang=js"
import style0 from "./addClassDialog.vue?vue&type=style&index=0&id=582b1e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b1e47",
  null
  
)

export default component.exports